export default __webpack_public_path__ + "static/media/apache.fe27b0e0.png";